<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="persistent">
    <v-card>
      <v-card-title class="text-h5 title">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="() => (dialog = !dialog)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot name="content"></slot>
        <div></div>
      </v-card-text>
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'undefined'
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.title {
  font-family: 'Prompt', sans-serif !important;
}
</style>
